export default __webpack_public_path__ + "static/media/ch_void_2.ad119b61.svg";